export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;
export const REQUIRE_AUTH = process.env.REACT_APP_REQUIRE_AUTH === "true";
export const DISCORD_CLIENT_ID = process.env.REACT_APP_DISCORD_CLIENT_ID;
export const DISCORD_REDIRECT_URI = process.env.REACT_APP_DISCORD_REDIRECT_URI;
export const DISCORD_OAUTH_SCOPE = process.env.REACT_APP_DISCORD_OAUTH_SCOPE || "identify guilds.members.read";
export const AUTH_TOKEN_STORAGE_KEY = "meowsearch.authToken";
export const AUTH_USER_STORAGE_KEY = "meowsearch.authUser";
export const AUTH_PROFILE_STORAGE_KEY = "meowsearch.authProfile";
export const AUTH_RETURN_PATH_STORAGE_KEY = "meowsearch.authReturnPath";
